 //****** Pincode Data Fetch Function ******
  function fetchPincodeData(pincode, cityClass, stateClass, errorClass) {
    const csvFile = "https://cdn.shopify.com/s/files/1/0021/8362/6851/files/pincode_data.csv?v=1718966385";

    if (pincode.length < 6) {
      // Display an error if the pincode is less than 6 digits
      const errorMessage = document.querySelector(`${errorClass}`);
      if (errorMessage) errorMessage.textContent = "Pincode must be 6 digits";
      return;
    }

    axios.get(csvFile)
      .then(response => {
        processData(response.data, pincode, cityClass, stateClass, errorClass);
      })
      .catch(error => {
        console.error("Error fetching the CSV file:", error);
      });
  }

  function processData(csv, pincode, cityClass, stateClass, errorClass) {
    const lines = csv.split("\n");
    let pincodeFound = false;
    let city, stateName;

    for (let i = 1; i < lines.length; i++) {
      const currentLine = lines[i].split(",");
      const currentPincode = currentLine[0].trim();

      if (currentPincode === pincode) {
        city = currentLine[1].trim();
        stateName = currentLine[2].trim();
        pincodeFound = true;
        break;
      }
    }

    const cityInput = document.querySelector(`${cityClass}`);
    const stateInput = document.querySelector(`${stateClass}`);
    const errorMessage = document.querySelector(`${errorClass}`);

    if (pincodeFound) {
      if (cityInput) cityInput.value = city;
      if (stateInput) stateInput.value = stateName;
      if (errorMessage) errorMessage.textContent = ""; // Clear any error message
    } else {
      if (cityInput) cityInput.value = "";
      if (stateInput) stateInput.value = "";
      if (errorMessage) errorMessage.textContent = "Pincode not found"; // Show error if pincode not found
    }
  }

  // Adding the function to the window object so it can be called globally
  window.fetchPincodeData = fetchPincodeData;



  
  